import React from 'react';
import LookerDashboard from "./LookerDashboard";
import _ from "lodash";
import {withRouter} from "react-router";
import {connect} from "react-redux";
import {API} from "aws-amplify";
import {toast} from "react-toastify";
import {isLookerReportsEnabled} from "../../shared/access";
import {Box, CircularProgress} from "@mui/material";

function mapStateToProps(state) {
    return state
}

function LookerIndex(props) {
    const [dashboardId, setActiveDashboardId] = React.useState(props.match.params.dashboardId);
    const [dashboards, setDashboards] = React.useState([]);
    const [activeDashboard, setActiveDashboard] = React.useState(null);
    let userInfo = props?.user?.aboutMe?.user;

    React.useEffect(() => {
        if (isLookerReportsEnabled()) {
            API.get('Core', '/api/v1/analytics/dashboard')
                .then(response => {
                    const transformedDashboards = _.sortBy((response || []).map(d => ({
                        ...d,
                        dashboardId: d.lookerId || formatDashboardId(d.dashboardId)
                    })), d => d.weight);

                    setDashboards(transformedDashboards);
                    if (!dashboardId) {
                        setActiveDashboard(transformedDashboards[0]);
                    }
                })
                .catch(error => {
                    toast("Could not load dashboards: " + error.response.data.message, {
                        position: "top-center",
                        type: "error"
                    });
                });
        }
    }, []);

    React.useEffect(() => {
        if (dashboards && dashboards.length > 0 && isLookerReportsEnabled()) {
            navigateToDashboard(dashboardId);
        }
    }, [dashboardId, dashboards, activeDashboard])

    const navigateToDashboard = (dashboardId) => {
        let activeDash = null;
        if(dashboardId){
            activeDash = _.find(dashboards, function(d){return d.dashboardId == dashboardId;})
            if(!activeDash){
                activeDash = dashboards[0];
            }
        }
        else{
            activeDash = dashboards[0];
        }
        setActiveDashboard(activeDash);
        setActiveDashboardId(activeDash.dashboardId);
        props.history.push("/reports/" + activeDash.dashboardId);
    }

    function formatDashboardId(id) {
        const dashboard = id.toLowerCase();
        if (dashboard.startsWith("survey")) {
            const suffix = id.substring("Survey".length);
            return `powerengage::survey__${suffix.toLowerCase()}`;
        } else if (dashboard === "eeb45213-2700-4f34-9151-6d62367f0bdf") {
            return `powerengage::albany_pd`;
        } else {
            return `powerengage::${id.toLowerCase()}`;
        }
    }
    const getActiveDashIdx = () => {
        return _.findIndex(dashboards, function(d){return d.dashboardId == activeDashboard?.dashboardId})
    }

    if (!isLookerReportsEnabled()) {
        return (<Box style={{display: 'block', height: '100vh'}}>
            <span className="inputText">Reports are disabled, please contact your administrator. </span>
        </Box>);
    }

    if (!dashboards || dashboards.length < 1 || !activeDashboard){
        return (<Box style={{ display:'block', height:'100vh' }}>
            <CircularProgress style={{position:'absolute',width:'40px', left:'45vw', top:'45vh'}} />
        </Box>);
    }

    return (
        <div style={{width: '100%', height: '100%', display: 'flex', flexDirection: 'column'}}>
            <div className="secondaryNavBar">
                <div className={`segmentedBar index${getActiveDashIdx()}`} style={{width: "100%"}}>
                    {
                        _.map(dashboards, function(d, dk){
                            return (
                                <div onClick={() => navigateToDashboard(d.dashboardId)} className={`segment ${d.dashboardId == activeDashboard.dashboardId ? 'selected' : ''}`} key={dk}>
                                    <div className="title">{d.name}</div>
                                </div>
                            );
                        })
                    }
                    <div className="selection" style={{left: (getActiveDashIdx() * (100 / dashboards.length)) + '%', width: (100 / dashboards.length) +'%' }}/>
                </div>
            </div>
            <div style={{width: '100%', flex: 1, minHeight: 0}}>
                { dashboardId ?
                    <LookerDashboard activeDashboard={activeDashboard} userInfo={userInfo} /> : ''
                }
            </div>
        </div>

    );
}

export default withRouter(connect(mapStateToProps)(LookerIndex));